module.exports = __webpack_public_path__ + "media/errors/403-error-5dd0f00c.png";